var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"unsaved-data-modal","cancel-title":"Go back","ok-title":"Proceed","hide-header":""},on:{"ok":_vm.proceed}},[_vm._v(" There's some unsaved data! ")])}
var staticRenderFns = []

export { render, staticRenderFns }